import type { UI } from '@/v2/types';
import React, { ComponentProps } from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  NakedButton,
} from '@qga/roo-ui/components';

import ReadMoreText from '@shared/v2/components/ReadMoreText/ReadMoreText';

import HighlightText from '@/v2/../components/HighlightText';
import htmlToReact from '@/v2/../utils/htmlToReact';
import HotelLocation from './components/HotelLocation';

interface Props {
  propertyContent: UI.Property;
  procuredOffer?: UI.ProcuredOffer | null;
}

const ReadMoreButton = (props: ComponentProps<typeof NakedButton>) => (
  <NakedButton
    fontWeight="bold"
    color="brand.primary"
    hoverColor="primaryDarker"
    {...props}
  />
);

const PackageOverview = React.memo(
  ({ propertyContent, procuredOffer }: Props) => {
    const tagline =
      procuredOffer?.highlights?.title ||
      procuredOffer?.offerDescription ||
      propertyContent?.tagline;

    const description =
      procuredOffer?.highlights?.description || propertyContent.description;

    return (
      <Box bg="white">
        <Container>
          <Flex py={['6', null, '12']} flexDirection={['column', null, 'row']}>
            <Box flex="1" mr={[null, null, '20']}>
              <Box>
                {tagline && (
                  <Heading.h5 data-testid="PROPERTY_TAGLINE" mb="2">
                    {tagline}
                  </Heading.h5>
                )}
                {description && (
                  <ReadMoreText ButtonComponent={ReadMoreButton} maxLines={6}>
                    {/* @ts-ignore */}
                    <HighlightText
                      data-testid="PROPERTY_DESCRIPTION"
                      fontSize="base"
                    >
                      {htmlToReact(description)}
                    </HighlightText>
                  </ReadMoreText>
                )}
              </Box>{' '}
            </Box>
            <Box mt={['6', null, '0']} flex={[null, null, '0 0 386px']}>
              <HotelLocation propertyContent={propertyContent} />
            </Box>
          </Flex>
        </Container>
      </Box>
    );
  },
);

export default PackageOverview;
